// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
Vue.prototype.axios=axios;
import locales from './assets/locales'
import VueI18n from 'vue-i18n'
import storage from './models/storage'
import promise from 'es6-promise'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
 promise.polyfill()

 Vue.use(BootstrapVue)
Vue.use(VueI18n) // 通过插件的形式挂载

import router from './router'

Vue.config.productionTip = false
/* i18n config */
 let lang = 'zh_cn'
// // if(['en', 'zh_cn', 'zh_tw'].indexOf(storage.get('lang')) > -1){
//  if(['zh_cn', 'zh_tw','en'].indexOf(storage.get('lang')) > -1){
//   lang = storage.get('lang')
// }
const i18n = new VueI18n({
  locale: lang,
  messages: locales
})

Vue.prototype.$locale = {
  change (language) {
    i18n.locale = language;
  },
  current () {
    return i18n.locale;
  }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js